var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-bundle-confirm"},[(_vm.bundle)?_c('bundle-preview',{attrs:{"bundle":_vm.bundle}}):_vm._e(),_c('div',{staticClass:"notice"},[_c('DsIcon',{staticClass:"alert",attrs:{"name":"alert-circle"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('campaignsPage.createBundle.notice')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }